export default function AdminNoticeIndexPage() {
	return <div>123</div>;
}
